import { DaoModel } from '@dynameat/models';

export class SocialMedia extends DaoModel {
  constructor(guid, isVisible, name, accountId, url, icon, posGuidList) {
    super(guid);
    this.isVisible = isVisible || false;
    this.name = name;
    this.accountId = accountId;
    this.url = url;
    this.icon = icon;
    this.posGuidList = posGuidList || [];
  }

  static toInstance(props = {}) {
    return new SocialMedia(props.guid, props.is_visible, props.name, props.account_id, props.url,
      props.icon, props.points_of_sale);
  }

  serialize() {
    return {
      ...super.serialize(),
      is_visible: this.isVisible,
      name: this.name,
      account_id: this.accountId,
      url: this.url,
      icon: this.icon,
      points_of_sale: this.posGuidList,
    };
  }

  getFormData() {
    const formData = new FormData();
    formData.append('is_visible', this.isVisible);
    formData.append('name', this.name);
    formData.append('account_id', this.accountId);
    formData.append('url', this.url);

    this.posGuidList.forEach((posGuid) => {
      formData.append('points_of_sale', posGuid);
    });

    if (this.icon instanceof File) {
      if (this.icon.size !== 0) {
        formData.append('icon', this.icon, this.icon.name);
      }
    } else if (!this.icon) {
      formData.append('icon', '');
    }
    return formData;
  }
}
